
import { ProcessStep } from "./ProcessStep";

export const ProcessSection = () => {
  const processSteps = [
    {
      number: 1,
      title: "Share Your Security Concerns",
      description: "Your journey begins by expressing what keeps you up at night about your security:",
      bulletPoints: [
        "Talk through your specific security worries in plain language without needing technical expertise",
        "Explain your business priorities and how security should enable them, not obstruct them",
        "Identify what security gaps make you most uncomfortable and what you want to protect most"
      ],
      testimonial: "Finally, someone who listened to my actual concerns instead of just running through a technical checklist. I felt understood for the first time.",
      testimonialAuthor: "Operations Director, Healthcare Provider"
    },
    {
      number: 2,
      title: "Your Clear Security Roadmap",
      description: "Receive a straightforward plan that addresses your specific concerns:",
      bulletPoints: [
        "See a security strategy tailored to your business priorities and risk tolerance",
        "Understand exactly how your protection will be implemented without business disruption",
        "Know precisely what you'll invest with transparent, predictable costs"
      ],
      testimonial: "For the first time, I could see exactly how our security would improve over time, with clear milestones and outcomes that made sense for our business.",
      testimonialAuthor: "CFO, Manufacturing Company"
    },
    {
      number: 3,
      title: "Smooth Transition to Better Security",
      description: "Experience a seamless implementation with minimal disruption:",
      bulletPoints: [
        "Continue business as usual while your security posture strengthens around you",
        "Gain visibility into your security status with intuitive dashboards",
        "Receive clear updates about each improvement as it's implemented"
      ],
      testimonial: "The transition was so smooth that our team barely noticed it happening. There was virtually no disruption to our daily operations, yet our security improved dramatically.",
      testimonialAuthor: "CTO, Financial Services"
    },
    {
      number: 4,
      title: "Continuous Protection & Growth",
      description: "Enjoy ongoing security that evolves with your business:",
      bulletPoints: [
        "Security risks are identified and neutralized before they can impact your business",
        "Regular reviews show how your security posture has improved",
        "Your security adapts as your business grows with guidance when you need it"
      ],
      testimonial: "When I see the quarterly report showing threats that were automatically prevented, I realize how much risk we've eliminated. I can finally focus on growth instead of worrying about security.",
      testimonialAuthor: "CEO, Technology Company"
    }
  ];

  return (
    <section className="py-24 bg-white" id="process">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-20">
          <span className="inline-block px-4 py-1.5 bg-edgefi-purple/10 text-edgefi-purple rounded-full text-sm font-medium mb-6">Your Success Journey</span>
          <h2 className="text-3xl sm:text-4xl font-bold mb-8 text-gray-900">
            Your Path to Security Peace of Mind
          </h2>
          <p className="text-xl text-gray-600">
            A straightforward journey that transforms your security experience and frees you to focus on your core business.
          </p>
        </div>
        
        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Vertical line */}
            <div className="absolute left-6 top-8 bottom-8 w-0.5 bg-gradient-to-b from-edgefi-purple/30 via-edgefi-amethyst/20 to-edgefi-purple/30 hidden sm:block"></div>
            
            <div className="space-y-16">
              {processSteps.map((step) => (
                <ProcessStep 
                  key={step.number}
                  number={step.number}
                  title={step.title}
                  description={step.description}
                  bulletPoints={step.bulletPoints}
                  testimonial={step.testimonial}
                  testimonialAuthor={step.testimonialAuthor}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
